import React, { useMemo } from "react";
import { BILLING_OPTIONS, OPTIONS, STATUS_OPTIONS } from "./config";
import DepartmentFilterDropDown from "components/Common/Dropdowns/DepartmentFilterDropDown";
import PanelDropDown from "components/Common/Dropdowns/PanelDropDown";
import InvestigationFilterDropdown from "components/Common/Dropdowns/InvestigationFilterDropdown";
import ZoneDropDown from "components/Common/Dropdowns/ZoneFilterDropDown";

const FilterPanelMaster = (props) => {
  const {
    filters,
    updateFilter,
    mrp,
    rate,
    mrpPercentage,
    ratePercentage,
    setMrp,
    setRate,
    setRatePercentage,
    setMrpPercentage,
    isSuperFranchise,
    isFranchise,
    isSubFranchise,
  } = props;

  const onRateChange = (event) => {
    const { value } = event.target;
    setRate(value);
    updateFilter("rate", value);
  };

  const onMrpChange = (event) => {
    const { value } = event.target;
    setMrp(value);
    updateFilter("mrp_rate", value);
  };

  const onRatePercentageChange = (event) => {
    const { value } = event.target;
    setRatePercentage(value);
    updateFilter("rate_percentage", value);
  };

  const onMrpPercentageChange = (event) => {
    const { value } = event.target;
    setMrpPercentage(value);
    updateFilter("mrp_percentage", value);
  };

  const filterVal = useMemo(() => {
    return (
      OPTIONS.find((option) => option.key === filters.keyword)?.value || ""
    );
  }, [filters]);

  const statusVal = useMemo(() => {
    return (
      STATUS_OPTIONS.find((option) => option.key === filters.is_active)
        ?.value || ""
    );
  }, [filters]);

  const billingCategoryVal = useMemo(() => {
    return (
      BILLING_OPTIONS.find((option) => option.key === filters.billing_category)
        ?.value || ""
    );
  }, [filters]);

  const setFilterValue = (keyname, value) => {
    updateFilter(keyname, value);
  };

  return (
    <>
      <div className="dropdown w-100 d-flex flex-row">
        <div className="dropdown ms-3">
          <button
            className="dropdown-toggle btn mt-1 btn-o box-shadow-none active"
            role="button"
            data-bs-toggle="dropdown"
            style={{ border: "solid 1px #DEE2E6", height: "38px" }}
          >
            {statusVal}
          </button>
          <ul className="dropdown-menu">
            {STATUS_OPTIONS.map(({ key, value }) => (
              <li
                className="dropdown-item"
                onClick={() => updateFilter("is_active", key)}
                key={key}
              >
                {value}
              </li>
            ))}
          </ul>
        </div>
        <div className="dropdown ms-3">
          <button
            className="dropdown-toggle btn mt-1 btn-o box-shadow-none active"
            role="button"
            data-bs-toggle="dropdown"
            style={{ border: "solid 1px #DEE2E6", height: "38px" }}
          >
            {billingCategoryVal}
          </button>
          <ul className="dropdown-menu">
            {BILLING_OPTIONS.map(({ key, value }) => (
              <li
                className="dropdown-item"
                onClick={() => updateFilter("billing_category", key)}
                key={key}
              >
                {value}
              </li>
            ))}
          </ul>
        </div>
        <div className="ms-3" style={{ width: "250px" }}>
          <InvestigationFilterDropdown
            setFilterValue={setFilterValue}
            className="w-100"
          />
        </div>
        <div className="ms-3" style={{ width: "250px" }}>
          <PanelDropDown
            setFilterValue={setFilterValue}
            showSuperFranchise={true}
            className="w-100"
          />
        </div>
      </div>
    </>
  );
};

export default FilterPanelMaster;
